import { View, ViewModel } from "binder";
import { SelectorBaseViewModel } from "src/common/reusableComponents/selectorBase/selectorBase-viewModel";
import { ServerConnection } from "src/server/serverConnection";

export class formSelectorViewModel extends SelectorBaseViewModel<form>{
    constructor(parent:ViewModel,prosessId:string) {
        super(parent,true);
        this._processId = prosessId;
        this.refresh();
    }
    private _processId:string;
    protected async loadData(): Promise<form[]> {
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/BpmsRawDataServices/GetProcessForms',{
                ProcessId : this._processId
            });
            return result.Forms.map(x=>{
                let r = new form(this);
                r.id=x.FormId;
                r.title = x.FormName;
                r.path = x.Path;
                return r;
            })
        } catch (ex) {
            console.log(ex);
            return Promise.resolve<form[]>([]);
        } finally {
            this.isLoading = false;
        }    
    }

}

export class form extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
        
    }
    
    public set id(v: string) { this._id = v; } public get id(): string { return this._id;} private _id: string;
    public set title(v: string) { this._title = v; } public get title(): string { return this._title;} private _title: string;
    public set path(v: string) { this._path = v; } public get path(): string { return this._path;} private _path: string;
}